module.exports = __webpack_public_path__ + "img/company_introduction.057d6a8.png";